import type { FC } from "react";

import { RadioButton, type RadioButtonProps } from "@jti/core-components";

import type { SortByItemDefinition } from "./SortBy.types";

export type SortByItemProps = SortByItemDefinition & {
  checked: boolean;
  onChecked: () => void;
};

export const SortByItem: FC<SortByItemProps> = ({ value, displayName, checked, onChecked }) => {
  const onChange: RadioButtonProps["onChange"] = (event) => {
    if (event.target.checked) {
      onChecked();
    }
  };

  return <RadioButton label={displayName} value={value} checked={checked} onChange={onChange}></RadioButton>;
};
